import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/index';

const features = [
  { title: 'Cloud Hosting', desc: 'Hosting berbasis cloud dengan auto-scaling untuk performa optimal saat traffic tinggi.', icon: '☁️' },
  { title: 'Cloud Backup', desc: 'Backup otomatis terjadwal dengan enkripsi end-to-end untuk keamanan data.', icon: '💾' },
  { title: 'Virtual Private Server', desc: 'VPS dengan resource terdedikasi dan akses root penuh.', icon: '🖥️' },
  { title: 'Cloud Storage', desc: 'Penyimpanan cloud fleksibel dengan akses dari mana saja dan kapan saja.', icon: '📦' },
  { title: 'CDN Services', desc: 'Content Delivery Network untuk mempercepat loading website di seluruh Indonesia.', icon: '⚡' },
  { title: 'Managed Kubernetes', desc: 'Orkestasi container dengan Kubernetes yang dikelola penuh oleh tim ahli kami.', icon: '🐳' },
];

const CloudServicesPage = () => {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <section className="relative bg-gradient-to-br from-cyan-900 via-teal-800 to-blue-900 text-white py-24 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Cloud Services</h1>
          <p className="text-lg md:text-xl text-cyan-200 max-w-3xl mx-auto">
            Solusi cloud enterprise yang skalabel, aman, dan hemat biaya untuk transformasi digital bisnis Anda.
          </p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800 dark:text-white">Layanan Cloud Kami</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f) => (
              <div key={f.title} className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="text-4xl mb-4">{f.icon}</div>
                <h3 className="text-xl font-bold mb-3 text-gray-800 dark:text-white">{f.title}</h3>
                <p className="text-gray-600 dark:text-gray-300">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-teal-900 text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Mulai Migrasi ke Cloud</h2>
          <p className="text-teal-200 mb-8">Tim kami siap membantu Anda merencanakan dan mengeksekusi migrasi cloud.</p>
          <Link to="/kontak" className="inline-block bg-white text-teal-900 font-bold px-8 py-4 rounded-xl hover:bg-teal-50 transition-colors">
            Konsultasi Gratis
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CloudServicesPage;
